import { render, staticRenderFns } from "./SelectMailDialog.vue?vue&type=template&id=2f172d90&scoped=true&"
import script from "./SelectMailDialog.vue?vue&type=script&lang=js&"
export * from "./SelectMailDialog.vue?vue&type=script&lang=js&"
import style0 from "./SelectMailDialog.vue?vue&type=style&index=0&id=2f172d90&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f172d90",
  null
  
)

export default component.exports